/**
 * Configuration for fraction warping: timing range and easing function.
 */

import { WarpingFunction } from './WarpingFunctionMapUtil';

export class FractionWarperTiming {
  public startFraction: number;
  public endFraction: number;
  public warpingFunction: WarpingFunction | null;

  constructor();
  constructor(warpingFunction: WarpingFunction | null);
  constructor(warpingFunction: WarpingFunction | null, startFraction: number, endFraction: number);

  constructor(warpingFunction: WarpingFunction | null = null, startFraction = 0.0, endFraction = 1.0) {
    this.warpingFunction = warpingFunction;
    this.startFraction = startFraction;
    this.endFraction = endFraction;
  }
}
